<template>
  <div class="jifen-detail" :style="{ height: clientHeight + 'px' }">

    <JifenItem :item="shopInfo"/>

    <div class="jifen-title">积分明细</div>

    <div class="jifen-soso fix">

      <div class="fl">
        积分明细：<z-input @keyup.enter="soso" v-model.trim="keyword" placeholder="明细编号、备注"/>
      </div>
      <div class="ml20 fl">
        明细类型：<z-select size="100" :zoptions="zoptions" v-model="integralType" placeholder="不限"></z-select>
      </div>

      <div class="ml20 fl">
        时间范围：<el-date-picker
            v-model="sData"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['12:00:00']">
          </el-date-picker>
      </div>

      <div class="fl top20">
        积分数值：
        <input class="z-input z-input-100" v-model="pointsA" placeholder="最小值">
         ~ <input class="z-input z-input-100" v-model="pointsB" placeholder="最大值">
      </div>
      
      
      <z-button class="ml20 va-bt fl top20"  size="primary" @click="soso">搜索</z-button>
      <z-button class="ml20 va-bt fl top20" @click="clickReset">重置</z-button>
    </div>

    <table class="wallet-box" >
            <colgroup>
              <col width="120" />
              <col width="120" />
              <col width="180" />
              <col width="140" />
              <col width="140" />
              <col />
            </colgroup>
            <thead>
                <tr>
                  <th class="first">编号</th>
                  <th class="first">类型</th>
                  <th class="first">时间</th>
                  <th class="first">积分</th>
                  <th class="first">凭证图片</th>
                  <th class="first">备注</th>
                </tr>
            </thead>
            <tbody>
              <tr class="order-info"  v-for="n in JifenDetail.datalist" :key="n.serialNo">
                    <td class="first">{{ n.serialNo }}</td>
                    <td class="first">{{ n.integralType | integralType }}</td>
                    <td class="first">{{ n.createtime }}</td>
                    <td class="first"><IconJifen size="gray" :points="(n.incomeExpenseType == 20 ? '-' : '+') + n.integral" /></td>
                    <td class="first wallet-a">
                      <img v-if="n.certificate" :src='n.certificate' @click="onMixImg(n.certificate)"/>
                      <span v-else>无</span>
                      
                      <!-- <span>无</span> -->
                    </td>
                    <td class="first w-s-b">{{ n.remark }}</td>
              </tr>
            </tbody>
    </table>
    <div v-if="imgShow" class="img-mix-bg" @click="imgShow = false"></div>
    <div class="img-mix" v-if="imgShow">
      <div class="closes" @click="imgShow = false">×</div>
      <img :src='imgUrl' />
    </div>
    

    <NoList v-if="JifenDetail.datalist.length == 0" title="暂没有积分明细" />
    
    <z-pager  v-if="JifenDetail.datalist.length > 0" size='blue' :pageCount="jifenPages" :clickHandler="onPage"></z-pager>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NoList from "../../components/no-list.vue";
import JifenItem from "../../components/jifen-item.vue";
import ZPager from "../../components/zPager";
import ZInput from "../../components/zInput";
import ZSelect from "../../components/zSelect";
import ZButton from "../../components/zButton";
import IconJifen from "../../components/icon-jifen";
const regJifen = /^-[0-9]*[1-9][0-9]*$|^[0-9]+$/;
export default {
  computed: {
    ...mapGetters(["JifenDetail", "shopInfo", "jifenPages", "clientHeight"])
  },
  components: {
    NoList,
    JifenItem,
    ZPager,
    ZInput,
    ZButton,
    ZSelect,
    IconJifen
  },
  data() {
    return {
      imgShow: false,
      imgUrl: "",
      sData: "",
      zoptions: [
        { name: "不限", id: "" },
        { name: "商品积分", id: 10 },
        { name: "兑换", id: 20 },
        { name: "退还", id: 30 },
        { name: "充值", id: 40 },
        { name: "扣减", id: 50 }
      ],
      keyword: "", // 搜索关键字
      integralType: "", // 积分类型
      pointsA: "",
      pointsB: ""
    };
  },
  watch: {
    pointsA(value, oldVal) {
      let newVal = new RegExp(regJifen).test(value)
        ? value
        : value == "-" || value == "" ? value : Number(value);
      if (newVal !== undefined) {
        if (isNaN(newVal) && newVal != "-") {
          this.pointsA = oldVal;
          return;
        }
      }
      if (newVal >= 99999999) newVal = 99999999;
      if (newVal <= -99999999) newVal = -99999999;
      if (Number(newVal) >= Number(this.pointsB) && this.pointsB != "")
        newVal = this.pointsB;

      this.pointsA = newVal;
    },
    pointsB(value, oldVal) {
      let newVal = new RegExp(regJifen).test(value)
        ? value
        : value == "-" || value == "" ? value : Number(value);
      if (newVal !== undefined) {
        if (isNaN(newVal) && newVal != "-") {
          this.pointsB = oldVal;
          return;
        }
      }
      if (newVal >= 99999999) newVal = 99999999;
      if (newVal <= -99999999) newVal = -99999999;
      if (Number(newVal) <= Number(this.pointsA) && this.pointsA != "")
        newVal = this.pointsA;
      this.pointsB = newVal;
    }
  },
  created() {
    this.getDetail(this.$route.params.id);
  },
  methods: {
    onMixImg(imgUrl) {
      this.imgShow = true;
      this.imgUrl = imgUrl;
    },
    getDetail(id) {
      this.$store.dispatch("JIFENDETAIL", id);
      this.$store.dispatch("SHOPINFO", id);
    },
    clickReset() {
      this.sData = "";
      this.keyword = "";
      this.integralType = "";
      this.pointsA = "";
      this.pointsB = "";
      this.soso();
    },
    soso() {
      if (
        (this.pointsA != '' && !new RegExp(regJifen).test(this.pointsA)) && this.pointsA == '-0' ||
        (this.pointsB != '' && !new RegExp(regJifen).test(this.pointsB)) && this.pointsB == '-0'
      ) {
        this.$message.error("积分数值输入有误");
        return;
      }

      this.$store.commit("JIFEN_SOSO_PAGE", { page: 1 });
      this.$store.commit("JIFEN_SOSO_PAGE_ONE");
      this.$store.commit("JIFEN_SOSO_KEY", this.keyword);
      this.$store.commit("JIFEN_SOSO_INT", this.integralType.id);
      this.$store.commit("JIFEN_SOSO_POINTSA", this.pointsA);
      this.$store.commit("JIFEN_SOSO_POINTSB", this.pointsB);
      this.$store.commit("JIFEN_SOSO_DATE", [
        !this.sData ? "" : this.onDates(this.sData[0]),
        !this.sData ? "" : this.onDates(this.sData[1])
      ]);

      this.$store.dispatch("JIFENDETAIL", this.$route.params.id);
    },
    onDates(e) {
      let date = new Date(e);
      var year = date.getFullYear();
      var month = date.getMonth() + 1; //月份
      var day = date.getDate(); //日
      var h = date.getHours(); //小时
      var m = date.getMinutes(); //分
      var s = date.getSeconds(); //秒

      return (
        [year, month, day].map(this.formatNumber).join("-") +
        " " +
        [h, m, s].map(this.formatNumber).join(":")
      );
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    onPage(o, size) {
      // 分页
      this.$store.commit("JIFEN_SOSO_PAGE", { page: o + 1, size: size });
      this.$store.dispatch("JIFENDETAIL", this.$route.params.id);
    }
  }
};
</script>
<style>
.img-mix-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.3;
  z-index: 666;
}
.img-mix {
  position: fixed;
  top: 100px;
  left: 50%;
  margin-left: -300px;
  width: 760px;
  height: 760px;
  border: 20px #fff solid;
  z-index: 667;
  background-color: #eee;
}
.img-mix img {
  max-width: 760px;
  max-height: 760px;
}
.img-mix .closes {
  position: absolute;
  top: -30px;
  right: -30px;
  font-size: 28px;
  color: #999;
  width: 42px;
  height: 42px;
  text-align: center;
  cursor: pointer;
  z-index: 6;
  font-weight: inherit;
  line-height: 42px;
}
.jifen-soso {
  margin: 20px 0;
  text-align: left;
}
.jifen-detail {
  padding: 30px 20px 20px;
  width: 1140px;
  margin: auto;
  overflow-y: auto;
}
.jifen-title {
  background-color: #f8f8f8;
  color: #999;
  padding: 10px;
  border: 1px solid #e7e7e7;
  text-align: left;
}

.wallet-box {
  margin: 0 0 10px;
}
.wallet-title {
  background-color: #f8f8f8;
  color: #999;
  padding: 10px;
  border: 1px solid #e7e7e7;
}
.wallet-box .icon {
  display: inline-block;
  width: 16px;
  height: 16px;

  margin-right: 4px;
  vertical-align: -3px;
}
.wallet-box .icon-us {
  display: inline-block;
  width: 21px;
  height: 18px;
  margin-right: 4px;
  vertical-align: -3px;
}
.wallet-box thead.hidden th {
  overflow: hidden;
  font-size: 0;
  padding: 0 10px;
  height: 0;
  line-height: 0;
  border: none;
}

.wallet-box thead {
  background-color: #f8f8f8;
  color: #999;
}

.wallet-box thead th.first {
  text-align: left;
  text-indent: 10px;
}

.wallet-box th,
.wallet-box td {
  line-height: 18px;
  padding: 10px 0;
}

.wallet-box td {
  vertical-align: middle;
}
.wallet-bg {
  margin: 0 0 10px;
}
.wallet-bg thead {
  background-color: #fff;
}

.m-uc-r-box-inner-detail .wallet-box td {
  border-right: none;
}
.m-uc-r-box-inner-detail .wallet-box th {
  font-weight: initial;
  background-color: #f8f8f8;
}

.wallet-box tfoot {
  background-color: #f8f8f8;
  text-align: left;
}

.wallet-box tfoot .price {
  font-size: 16px;
  color: #ee8c3a;
}

.wallet-box tfoot th {
  text-align: left;
  padding: 35px 20px;
  font-weight: normal;
}

.wallet-box tfoot td {
  text-align: left;
  padding-left: 60px;
}

.wallet-box tr.title td {
  text-align: left;
  border-bottom: none;
}
.wallet-box tr.title td.first {
  background-color: #f8f8f8;
  border-bottom: 1px solid #e7e7e7;
  text-indent: 10px;
}

.wallet-box tr td img {
  width: 40px;
  height: 40px;
  margin-right: 6px;
  vertical-align: middle;
}

.wallet-box td.no-border {
  border-right: none;
}

.wallet-box .m-button {
  width: 90px;
  margin-bottom: 5px;
  cursor: pointer;
  padding: 0 6px;
}

.wallet-box .countdown {
  margin-bottom: 7px;
}

.wallet-box [name="cancel-order"] {
  cursor: pointer;
}

.wallet-box .order-info .first {
  text-align: left;
  padding: 10px;
  height: 40px;
}
.wallet-red {
  color: #ee8c3a;
  font-size: 14px;
}
.wallet-no td {
  color: #ccc;
}
.wallet-btn {
  display: block;
  line-height: 30px;
}
.wallet-a a {
  display: block;
}
.m-uc-filter .m-button.fl {
  float: left;
}

.ant-calendar-picker .ant-input {
  height: 36px;
  border-radius: 0;
}
.el-input__inner {
  height: 34px;
  line-height: 34px;
}
.el-range-editor.el-input__inner {
  padding: 0 10px;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 360px;
}
.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 12px;
}
</style>
